import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-awesome-bookmark-icon",
  "use": "icon-awesome-bookmark-icon-usage",
  "viewBox": "0 0 11.693 15.647",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.693 15.647\" id=\"icon-awesome-bookmark-icon\"><defs><style>#icon-awesome-bookmark-icon .a{fill:none;stroke:#b2b2b2;stroke-width:1.5px;}</style></defs><path class=\"a\" d=\"M0,13.591V1.274A1.274,1.274,0,0,1,1.274,0H8.919a1.274,1.274,0,0,1,1.274,1.274V13.591L5.1,10.618Z\" transform=\"translate(0.75 0.75)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol